
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_mweql_93",
  "input": "awsui_input_4yi2u_mweql_105",
  "toggle-control": "awsui_toggle-control_4yi2u_mweql_127",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_mweql_136",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_mweql_139",
  "toggle-handle": "awsui_toggle-handle_4yi2u_mweql_146",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_mweql_157",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_mweql_160"
};
  